export const FETCH_USB_DETECTION = "FETCH_USB_DETECTION";
export const FETCH_USB_DETECTION_SUCCESS = "FETCH_USB_DETECTION_SUCCESS";
export const FETCH_USB_DETECTION_FAILED = "FETCH_USB_DETECTION_FAILED";

export const FETCH_USB_DETECTION_REPORT = "FETCH_USB_DETECTION_REPORT";
export const FETCH_USB_DETECTION_REPORT_SUCCESS =
  "FETCH_USB_DETECTION_REPORT_SUCCESS";
export const FETCH_USB_DETECTION_REPORT_FAILED =
  "FETCH_USB_DETECTION_REPORT_FAILED";

export const DOWNLOAD_USB_DETECTION = "DOWNLOAD_USB_DETECTION";
export const DOWNLOAD_USB_DETECTION_SUCCESS = "DOWNLOAD_USB_DETECTION_SUCCESS";
export const DOWNLOAD_USB_DETECTION_FAILED = "DOWNLOAD_USB_DETECTION_FAILED";

export const DOWNLOAD_USB_DETECTION_REPORT = "DOWNLOAD_USB_DETECTION_REPORT";
export const DOWNLOAD_USB_DETECTION_REPORT_SUCCESS =
  "DOWNLOAD_USB_DETECTION_REPORT_SUCCESS";
export const DOWNLOAD_USB_DETECTION_REPORT_FAILED =
  "DOWNLOAD_USB_DETECTION_REPORT_FAILED";
